import React, { useMemo } from 'react';
import { Table, type TableColumn as EqualDSTableColumn } from 'equal-ds-ui';
import type {
  AnalyticsPortalTableProps,
  TableRow,
} from '../../../services/analytics-service';

const PAGE_SIZE_OPTIONS = [10, 20, 50];

const renderCellValue = (value: any): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return String(value);
};

export const AnalyticsPortalTable: React.FC<AnalyticsPortalTableProps> = ({
  columns: apiColumns,
  data,
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  isLoading,
  dropdownZIndex,
}) => {
  // Explicitly compute totalPages
  const totalPages = totalItems ? Math.ceil(totalItems / pageSize) : undefined;

  const tableColumns: EqualDSTableColumn<TableRow>[] = useMemo(() => {
    return apiColumns.map((col) => ({
      key: col.key,
      header: col.label,
      width: 150,
      render: (_value, row) => (
        <span className="text-sm">
          {renderCellValue(row[col.key])}
        </span>
      ),
    }));
  }, [apiColumns]);

  return (
    <div className="flex-1 min-h-0 flex flex-col">
      {/* Table */}
      <div className="flex-1 min-h-0 flex flex-col">
        <Table
          className="flex-1 min-h-0 shadow-sm rounded-xl"
          data={data}
          columns={tableColumns}
          loading={isLoading}
          pagination={{
            currentPage,
            pageSize,
            totalItems,
            totalPages,
            onPageChange,
            onPageSizeChange,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showPageSizeSelector: true,
            dropdownZIndex,
          }}
        />
      </div>
    </div>
  );
};
